module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-web"
  }, [_c('hd-header'), _vm._v(" "), _c('section', {
    staticClass: "hd-web-content"
  }, [_c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content clear"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "sliderContainer"
  }, [_c('slider', {
    attrs: {
      "width": "192px",
      "height": "338px",
      "interval": 3000,
      "speed": 500,
      "control-btn": false
    }
  }, [_c('slider-item', [_c('img', {
    attrs: {
      "src": require("assets/images/img-1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    attrs: {
      "src": require("assets/images/img-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    attrs: {
      "src": require("assets/images/img-3.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    attrs: {
      "src": require("assets/images/img-4.png"),
      "alt": ""
    }
  })])], 1)], 1)]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('hd-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("海渡职校APP")]), _vm._v(" "), _c('p', [_vm._v("颠覆传统课堂学习，您身边的机器人学院。")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:;",
      "onclick": "javascript:document.getElementById('download').scrollIntoView()"
    }
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v("APP下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("专业的工业机器人学习资源只在\n          "), _c('span', {
    staticStyle: {
      "color": "#24b2f9"
    }
  }, [_vm._v("海渡职校")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content clear"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_shuji.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("专业的配套教材")]), _vm._v(" "), _c('p', [_vm._v("机器人领域专家教师及职业教育领域优秀教师潜心编纂。")]), _vm._v(" "), _c('p', [_vm._v("工业机器人技术专业 “十三五” 规划教材")]), _vm._v(" "), _c('p', [_vm._v("工业机器人应用人才培养指定用书")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_live.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("丰富的视频教学资源")]), _vm._v(" "), _c('p', [_vm._v("行业资深高级工程师现场录制")]), _vm._v(" "), _c('p', [_vm._v("结合实物装备，针对知识点细化分解")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    staticStyle: {
      "background-color": "#f4f8fb",
      "padding-bottom": "90px"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("全网独一无二")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('h3', {
    staticClass: "tip"
  }, [_vm._v("免费优质课程、专注工业机器人教育；工业机器人学习从入门到精通")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_duyiwuer.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sys-up"
  }, [_vm._v("系统式进阶成长")]), _vm._v(" "), _c('p', {
    staticClass: "ln-plat"
  }, [_vm._v("首款机器人学习平台")]), _vm._v(" "), _c('p', {
    staticClass: "dis"
  }, [_vm._v("名校零距离")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content clear"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("全新学习体验")]), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "margin-left": "0"
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("更新的学习方式：")]), _vm._v(" "), _c('span', [_vm._v("提供工业机器人领域轻量学习内容")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("每一块碎片时间都可以被更好地利用")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("更快的成长路径：")]), _vm._v(" "), _c('span', [_vm._v("除了轻量学习内容，还有更为丰富")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("的进阶式学习系统，工业机器人学习，拾级而上")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("更好的学习效果：")]), _vm._v(" "), _c('span', [_vm._v("结合个性推荐、学习任务管理等多")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("项功能、帮助你有效提升学习效果，成就机器人指挥官")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_xuexitiyan.png"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    staticStyle: {
      "background-color": "#f4f8fb",
      "padding-bottom": "90px"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content clear"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "margin-right": "30px",
      "width": "450px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_qiandao.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "width": "auto",
      "margin-right": "0"
    }
  }, [_c('h1', [_vm._v("签到送积分，自由兑换书籍和教学资源")]), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "margin-left": "0"
    }
  }), _vm._v(" "), _c('p', [_vm._v("签到都有积分送，连续签到更有玫瑰和游轮")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("邀请好友送400积分，8个好友加入就能免费得书籍")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "download-area",
    attrs: {
      "id": "download"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h1', [_vm._v("根据您的手机，选择下载")]), _vm._v(" "), _c('div', {
    staticClass: "content clear"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "iphone",
    attrs: {
      "href": "https://itunes.apple.com/us/app/%E6%B5%B7%E6%B8%A1%E5%AD%A6%E9%99%A2/id1249979481?ls=1&mt=8"
    }
  }, [_vm._v("iPhone版本下载")]), _vm._v(" "), _c('a', {
    staticClass: "android",
    attrs: {
      "href": "http://sj.qq.com/myapp/detail.htm?apkName=com.haidu.academy"
    }
  }, [_vm._v("Android版本下载")])]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('img', {
    attrs: {
      "src": "http://edubot-1252617679.picsh.myqcloud.com/2017_08_09_1606309518.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫下载APP")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6136f7ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 370
// module chunks = 1